import React from 'react'
import { useIntl } from 'react-intl'

import s from './styles.module.scss'

import ControlledSelectField from '../../../../../../../../../forms/select-field/ControlledSelectField'
import { getVatRateOptions } from '../../../../../../../shared/utils/house-options.utils'
import { HouseNightlyTripGlobalFieldProps } from '../../../form-container/HouseNightlyTripGlobalFormContainer'

type HouseNightlyTripGlobalVatFieldProps = HouseNightlyTripGlobalFieldProps & {
  name: 'options.vatRate' | 'options.flexibleSchedule.vatRate'
}
export const HouseNightlyTripGlobalVatField = ({
  control,
  isFieldDisabled,
  currencyArea,
  name,
}: HouseNightlyTripGlobalVatFieldProps) => {
  const intl = useIntl()
  return (
    <div className={s.vatRate}>
      <ControlledSelectField
        control={control}
        rules={{ required: 'Champ requis.' }}
        name={name}
        labelClassName={s.vatRateLabel}
        inline={true}
        menuPlacement='top'
        label={
          name === 'options.vatRate'
            ? intl.formatMessage({
                defaultMessage: 'TVA applicable aux nuitées',
                id: 'ui.HouseNightlyTripGlobalVatField.label.nights',
              })
            : intl.formatMessage({
                defaultMessage: 'TVA applicable aux suppléments',
                id: 'ui.HouseNightlyTripGlobalVatField.label.supplements',
              })
        }
        options={getVatRateOptions(currencyArea.vatRates)}
        disabled={isFieldDisabled}
        placeholder={intl.formatNumber(0, {
          style: 'percent',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      />
    </div>
  )
}
